<template>
    <!-- <lottie-player src="/loader_2.json"  background="transparent"  speed="1"  loop  autoplay></lottie-player> -->
    <lottie-player
        :src="loader"
        background="transparent"
        speed="1"
        loop
        autoplay
    ></lottie-player>
</template>

<script setup>
defineProps({
    loader: {
        type: String,
        required: false,
        default: '/loader_3.json',
    },
});
</script>
